export default __webpack_public_path__ + "static/media/browser_tab_example.d17ca8cf.svg";